'use client'

import UpgradeButton from '@/components/access/UpgradeButton'
import SignUpForm from '@/components/forms/SignUpForm'
import { PLANS } from '@/constants/plans'
import Link from 'next/link'

// Free and Unlimited side by side (2026-11-01): the limit screen and /join,
// the plans page. The plan this reader should take next is ruled in ink
// and carries the action; the other is quieter.
//
//   guest  Free leads (email field); Unlimited signs up with the same
//          email field and comes back to /join?plan=unlimited, which sends
//          the new subscriber straight to checkout. `compact` (the limit
//          screen) links Unlimited to /join instead of a second field.
//   free   Unlimited leads (checkout); Free is marked as their plan, with
//          `note` under it (when their free stories come back).
export default function PlanCards({
  tier,
  surface,
  compact = false,
  note = null,
}) {
  const guest = tier === 'guest'
  const card = (lead) =>
    `flex flex-col p-5 sm:p-6 ${
      lead ? 'border-2 border-foreground bg-card' : 'border border-border'
    }`
  const head = (plan, mine) => (
    <>
      <p className="flex items-baseline justify-between gap-3">
        <span className="font-sans text-xs font-semibold uppercase tracking-[0.12em] text-foreground">
          {plan.name}
        </span>
        {mine && (
          <span className="font-sans text-xs text-muted-foreground">
            Your plan
          </span>
        )}
      </p>
      <p className="mt-2 font-serif text-[28px] leading-none text-foreground">
        {plan.price}
      </p>
      <ul className="mt-4 flex-1 space-y-1.5 font-sans text-sm leading-snug text-foreground/85">
        {plan.points.map((p) => (
          <li key={p} className="flex gap-2">
            <span aria-hidden="true" className="text-muted-foreground">
              ✓
            </span>
            {p}
          </li>
        ))}
      </ul>
    </>
  )

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div className={card(guest)}>
        {head(PLANS.free, !guest)}
        <div className="mt-5">
          {guest ? (
            <SignUpForm
              card
              buttonLabel="Subscribe free"
              trackingLocation={surface}
            />
          ) : (
            note && (
              <p className="font-sans text-[13px] text-muted-foreground">
                {note}
              </p>
            )
          )}
        </div>
      </div>
      <div className={card(!guest)}>
        {head(PLANS.unlimited, false)}
        <div className="mt-5">
          {!guest ? (
            <UpgradeButton surface={surface} label="Get unlimited" fullWidth />
          ) : compact ? (
            <Link
              href="/join?plan=unlimited"
              className="font-sans text-sm font-semibold text-foreground underline underline-offset-4 hover:decoration-2"
            >
              Go unlimited &rarr;
            </Link>
          ) : (
            <>
              <SignUpForm
                card
                buttonLabel="Continue"
                trackingLocation={`${surface}_unlimited`}
                next="/join?plan=unlimited"
              />
              <p className="mt-2 font-sans text-xs text-muted-foreground">
                We&apos;ll email you a code to confirm your address, then
                you&apos;ll pay securely with Stripe.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
